import React, { Component } from "react";
import Header from "../Shared/Header";
import IconInput from "../Shared/IconInput";
import SuccessAlert from "../Shared/SuccessAlert";
import logo from "./../../assets/image/icon.png";
import SignupService from "./Signup.service";
import "./Signup.scss";
import userp from "../../assets/image/icon/profile black.png";
import data from "../../assets/image/icon/data black.png";
import mail from "../../assets/image/icon/mail black.png";
import pwd from "../../assets/image/icon/password black.png";
export default class Signup extends Component {
    state = {
        name: undefined,
        nameIsInvalid: false,
        lastName: undefined,
        lastNameIsInvalid: false,
        username: undefined,
        usernameIsInvalid: false,
        email: undefined,
        emailIsInvalid: false,
        password: undefined,
        passwordIsInvalid: false,
        passwordVerification: undefined,
        passwordVerificationIsInvalid: false,
        success: false,
        isLoading: false
    };

    goToLogin = () => {
        this.props.history.push("/login");
    };

    signup = () => {
        if (
            !this.state.name ||
            !this.state.lastName ||
            !this.state.username ||
            this.state.usernameIsInvalid ||
            !this.state.email ||
            this.state.emailIsInvalid ||
            !this.state.password ||
            !this.state.passwordVerification
        ) {
            let newState = {};
            if (!this.state.name) newState.nameIsInvalid = "Field is required";
            if (!this.state.lastName)
                newState.lastNameIsInvalid = "Field is required";
            if (!this.state.username)
                newState.usernameIsInvalid = "Field is required";
            if (!this.state.email)
                newState.emailIsInvalid = "Field is required";
            if (!this.state.password)
                newState.passwordIsInvalid = "Field is required";
            if (!this.state.passwordVerification)
                newState.passwordVerificationIsInvalid = "Field is required";
            this.setState(newState);
            return;
        }

        let newState = {};
        const isEmailValid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!isEmailValid.test(this.state.email.toLowerCase())) {
            newState.emailIsInvalid = "Email is not valid";
        }

        if (this.state.password !== this.state.passwordVerification) {
            newState.passwordVerificationIsInvalid = "Passwords don't match";
        }

        if (Object.entries(newState).length !== 0) {
            this.setState(newState);
            return;
        }

        this.setState({
            isLoading: true
        });

        SignupService.signup(
            this.state.name,
            this.state.lastName,
            this.state.username,
            this.state.email,
            this.state.password
        )
            .then(response => {
                this.setState({
                    success: true
                });
            })
            .catch(error => {
                this.props.alert({
                    theme: "error",
                    message: error.message
                });
                this.setState({
                    isLoading: false
                });
            });
    };

    onKeyPress = e => {
        if (e.key === "Enter") {
            this.signup();
        }
    };

    onNewNameValue = e => {
        if (this.state.nameIsInvalid)
            this.setState({
                nameIsInvalid: false
            });

        this.setState({
            name: e.target.value
        });
    };

    onNewLastNameValue = e => {
        if (this.state.lastNameIsInvalid)
            this.setState({
                lastNameIsInvalid: false
            });

        this.setState({
            lastName: e.target.value
        });
    };

    onNewUsernameValue = e => {
        if (this.state.usernameIsInvalid)
            this.setState({
                usernameIsInvalid: false
            });

        this.setState({
            username: e.target.value
        });

        SignupService.usernameExists(e.target.value)
        .then(response => {
            this.setState({
                usernameIsInvalid: response.response
            });
        })
        .catch(error => {
        });

        if(/\s/g.test(e.target.value)){
            this.setState({
              usernameIsInvalid: "Username can't have spaces",
            });
          }
    };

    onNewEmailValue = e => {
        if (this.state.emailIsInvalid)
            this.setState({
                emailIsInvalid: false
            });

        this.setState({
            email: e.target.value
        });

        SignupService.emailExists(e.target.value)
            .then(response => {
                this.setState({
                    emailIsInvalid: response.response
                });
            })
            .catch(error => {
            });
    };

    onNewPasswordValue = e => {
        if (this.state.passwordIsInvalid)
            this.setState({
                passwordIsInvalid: false
            });

        this.setState({
            password: e.target.value
        });
    };

    onNewPasswordVerificationValue = e => {
        if (this.state.passwordVerificationIsInvalid)
            this.setState({
                passwordVerificationIsInvalid: false
            });

        this.setState({
            passwordVerification: e.target.value
        });
    };

    render() {
        return (
            <div>
                <Header />
                <div className="login d-flex justify-content-center align-items-center">
                    <div className="position-relative login-box d-flex flex-column justify-content-center align-items-center">
                        {this.state.success ? (
                            <SuccessAlert message="Account created!">
                                <button
                                    className="btn btn-outline-light mt-3"
                                    onClick={this.goToLogin}
                                >
                                    Log in now!
                                </button>
                            </SuccessAlert>
                        ) : (
                            ""
                        )}
                        <div className="d-flex w-100 align-items-center mb-3">
                            <img
                                className="icon-login mb-2"
                                src={logo}
                                alt="Huckleberry logo"
                            />
                            <h1 className="ml-2">Signup</h1>
                        </div>

                        <IconInput
                            isInvalid={this.state.nameIsInvalid}
                            onValueChange={this.onNewNameValue}
                            onKeyPress={this.onKeyPress}
                            icon={data}
                            type="text"
                            placeholder="Name"
                        />
                        <IconInput
                            isInvalid={this.state.lastNameIsInvalid}
                            onValueChange={this.onNewLastNameValue}
                            onKeyPress={this.onKeyPress}
                            icon={data}
                            type="text"
                            placeholder="Last name"
                        />
                        <IconInput
                            alertContent="Use a username"
                            isInvalid={this.state.usernameIsInvalid}
                            onValueChange={this.onNewUsernameValue}
                            onKeyPress={this.onKeyPress}
                            icon={userp}
                            type="text"
                            placeholder="Username"
                        />
                        <IconInput
                            isInvalid={this.state.emailIsInvalid}
                            onValueChange={this.onNewEmailValue}
                            onKeyPress={this.onKeyPress}
                            icon={mail}
                            type="email"
                            placeholder="E-mail"
                        />
                        <IconInput
                            isInvalid={this.state.passwordIsInvalid}
                            onValueChange={this.onNewPasswordValue}
                            onKeyPress={this.onKeyPress}
                            icon={pwd}
                            type="password"
                            placeholder="Password"
                        />
                        <IconInput
                            isInvalid={this.state.passwordVerificationIsInvalid}
                            onValueChange={this.onNewPasswordVerificationValue}
                            onKeyPress={this.onKeyPress}
                            icon={pwd}
                            type="password"
                            placeholder="Confirm password"
                        />
                        <button
                            type="button"
                            className="btn btn-primary mt-1 mb-2 w-100 btn-signup"
                            onClick={this.signup}
                            disabled={this.state.isLoading}
                        >
                            {this.state.isLoading ? (
                                <div
                                    id="btn-login-spinner"
                                    className="spinner-border spinner-border-sm text-light"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                "Sign up"
                            )}
                        </button>
                        <a href="login">Already a member? Log in now</a>
                    </div>
                </div>
            </div>
        );
    }
}
